import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/google-session", { session_id });
        localStorage.setItem("vibelead_token", r.data.token);
        setUser(r.data.user);
        toast.success("Logged in via Google");
        // Clean URL fragment
        window.history.replaceState(null, "", window.location.pathname);
        navigate(r.data.user.role === "admin" ? "/admin" : "/dashboard", { state: { user: r.data.user } });
      } catch (err) {
        toast.error("Google authentication failed");
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="card-brutal px-8 py-6 font-display text-xl" data-testid="auth-callback-loading">Authenticating…</div>
    </div>
  );
}
